import apiEndpoint from '../../api/etrBackend'
import {
  POLICY_DETAIL_FAILED,
  POLICY_DETAIL_FETCHING,
  POLICY_DETAIL_SUCCESS,
  server
} from '../../constants'
import { encryptQueryString } from '../../helpers/cipher'
import { isMaskingData } from '../../helpers/texthelper'
import { AgentModel } from '../../models/agent'
import { PolicyModel } from '../../models/policy'
import { RootReducers } from '../reducers'

const setStatePolicyDetailToSuccess = (payload: any) => ({
  type: POLICY_DETAIL_SUCCESS,
  payload: payload
})

const setStatePolicyDetailToFetching = () => ({
  type: POLICY_DETAIL_FETCHING
})

const setStatePolicyDetailToFailed = () => ({
  type: POLICY_DETAIL_FAILED
})

export const getPolicyDetail = (policyNumber: string) => {
  return async (dispatch: any, getState: () => RootReducers) => {
    try {
      dispatch(setStatePolicyDetailToFetching())
      const agentInfo = getState().loginReducer.account?.agentInfo
      const queryString = encryptQueryString(policyNumber)
      const result = await apiEndpoint.get<PolicyModel[]>(`${server.POLICY}?q=${queryString}`)

      let data = result.data

      if (Array.isArray(result.data)) {
        data = result.data.map(item => ({
          ...item,
          isServiceAgent: !isMaskingData(
            agentInfo as AgentModel,
            item.AgentNumber as string,
            agentInfo?.AgentUnderAOs
          )
        }))
      }
      dispatch(setStatePolicyDetailToSuccess(data))
    } catch (error) {
      dispatch(setStatePolicyDetailToFailed())
    }
  }
}

export const resetData = () => {
  return async (dispatch: any) => {
    try {
      dispatch(setStatePolicyDetailToSuccess(null))
    } catch (error) {
      dispatch(setStatePolicyDetailToFailed)
    }
  }
}
